import http from '../utils/fetch';
export default {
    insert(query) {
        return http({
            url: '/api/swyl/v1/agent/bscUserInfoAgent/insert',
            method: 'post',
            data: query
        });
    },
    insertDls(query) {
        return http({
            url: '/api/swyl/v1/agent/bscUserInfoAgent/insertDls',
            method: 'post',
            data: query
        });
    },
    insertGYDls(query) {
        return http({
            url: '/api/swyl/v1/agent/bscUserInfoAgent/insertGYDls',
            method: 'post',
            data: query
        });
    },
    saveGYDls(query) {
        return http({
            url: '/api/swyl/v1/agent/bscUserInfoAgent/saveGYDls',
            method: 'post',
            data: query
        });
    },
    insertXjDls(query) {
        return http({
            url: '/api/swyl/v1/agent/bscUserInfoAgent/insertXjDls',
            method: 'post',
            data: query
        });
    },
    insertKs(query) {
        return http({
            url: '/api/swyl/v1/agent/bscUserInfoAgent/insertKs',
            method: 'post',
            data: query
        });
    },
    update(query) {
        return http({
            url: '/api/swyl/v1/agent/bscUserInfoAgent/updateAll',
            method: 'post',
            data: query
        });
    },
    selectAddress() {
        return http({
            url: '/api/swyl/v1/agent/bscUserInfoAgent/selectAddress',
            method: 'post'

        });
    },
    getAgentByContract(customerName) {
        return http({
            url: '/api/swyl/v1/agent/bscUserInfoAgent/getAgentByContract?customerName='+customerName,
            method: 'post'
        });
    },

    insertSupplier(query) {
        return http({
            url: '/api/swyl/v1/supplier/SupplierController/insert',
            method: 'post',
            data: query
        });
    },
     checkCompany(userName) {
        return http({
            url: '/api/swyl/v1/supplier/SupplierController/checkCompany',
            method: 'post',
            params: {userName}
        });
},
    updateUploadFile(updateFile) {
        const formData = new FormData();
        formData.append("idList", updateFile.idList);
        formData.append("refid", updateFile.refid);
        return http({
            url: '/api/file/fileopt/updateAllowNotLogin',
            method: 'post',
            data: formData
        });
    },
    checkAgentCompany(companyName,isOldAgent) {
        return http({
            url: '/api/bscUserInfoAgentBasic/checkAgentCompany',
            method: 'post',
            params: {companyName,isOldAgent}
        });
    },
    getBackName(v) {
        return http({
            url: '/api/swyl/v1/bankconfig/mdmBankconfig/getBankconfig',
            method: 'post',
            params: v
        });
    },
    queryAgent(usercode) {
        return http({
            url: '/api/swyl/v1/viewagentlist/viewAgentList/selectByUsercode',
            method: 'post',
            params: {usercode}
        });
    },
    getCityCode(xz) {
        return http({
            url: '/api/swyl/v1/basic/bscAddr/getCityXzCode',
            method: 'post',
            params: {xz}
        });
    },

    getInstidByName(companycodeForLookFlow) {
        return http({
            url: '/api/swyl/v1/agent/bscUserInfoAgent/getInstidByName',
            method: 'post',
            params: {companycodeForLookFlow}
        });
    },

    getBackUserInfo(userName,email) {
        return http({
            url: '/api/swyl/v1/agent/bscUserInfoAgent/getBackUserInfo',
            method: 'post',
            params: {userName,email}
        });
    },
    getMdmAgent(name,value) {
        return http({
            url: '/api/swyl/v1/agent/bscUserInfoAgent/getMdmAgent',
            method: 'get',
            params: {name,value}
        });
    },
    getContractByName(userName) {
        return http({
            url: '/api/swyl/v1/hetong/bscContract/getContractByName?username='+userName,
            method: 'post',
        });
    },
    getFneixaoAgent(userName,email) {
        return http({
            url: '/api/swyl/v1/agent/bscUserInfoAgent/getFneixaoAgent',
            method: 'post',
            params: {userName,email}
        });
    },
//评分表接口
    updateByIdScore(query) {
        return http({
            url: '/api/swyl/v1/demo/bscUserInfoAgentScore/updateById',
            method: 'post',
            params: query,
        });
    },

    selectScore(query) {
        return http({
            url: '/api/swyl/v1/demo/bscUserInfoAgentScore/selectScore',
            method: 'post',
            params: query,
        });
    },
    //获取当前登录人领域
    getField(){
        return http({
            url: '/api/swyl/v1/bscUserAuth/getField',
            method: 'post',
        });
    },
    //经销商康盛注册
    insertKsService(){
        return http({
            url: '/api/swyl/v1/agent/bscUserInfoAgent/insertKsService',
            method: 'post',
        });
    }

}
